import React, { useEffect } from 'react';

import { loadScript } from '@crehana/utils';

import { URLS } from 'Jsx/CheckoutV4/common/constants';
import { Stripe } from 'Jsx/CheckoutV4/types/StripeV2';

import { publishStripePublicKey } from './publishStripePublicKey';

const useStripeV2Lib = () => {
  const [isLoadingStripeLib, setIsLoadingStripeLib] = React.useState(true);
  const [stripeLib, setStripeLib] = React.useState<Stripe | undefined>(
    window.Stripe,
  );

  useEffect(() => {
    if (!window.Stripe) {
      loadScript({ src: URLS.stripev2 })
        .then(res => {
          if (res) {
            setIsLoadingStripeLib(false);
            setStripeLib(window.Stripe);
            publishStripePublicKey(window.Stripe);
          }
        })
        .catch(error => {
          throw new Error(`stripe library failed to load: ${error?.message}`);
        });
    } else {
      setIsLoadingStripeLib(false);
    }
  }, []);
  return { isLoadingStripeLib, stripeLib };
};

export default useStripeV2Lib;
